import React from 'react'
import './styles/bubbleLoader.scss'

const BubbleLoader = ({ style, cssClass }) => (
    <div id="uc-bubble-loader" className={cssClass} style={style} />
)

export default BubbleLoader
